import { Typography } from "@material-ui/core";

import { COLORS } from "../../../theme/colors";

export const SelectFilterComponent = ({ title, byFilter, onClick }) => {
  return (
    <Typography
      variant="h4"
      onClick={onClick}
      style={{
        color: `${title.toUpperCase() === byFilter ? COLORS.red : COLORS.darks[0][100]}`,
        cursor: "pointer",
      }}
    >
      {title}
    </Typography>
  );
};
